export default __webpack_public_path__ + "de_aggregation_formula.png";